/** -- Umami event names (max 50 characters). Shared by all analytics providers. */
export const AnalyticsEvents = {
  NAV_CLICK: 'nav_click',
  SEARCH: 'search',
  SEARCH_PICK: 'search_pick',
  SEARCH_NO_MATCH: 'search_no_match',
  FILTER_COMPOSITE: 'filter_composite',
  FILTER_SCALE: 'filter_scale',
  EXPLORER_CLEAR: 'explorer_clear',
  EXPLORER_PICK: 'explorer_pick',
  THEME_CHANGE: 'theme_change',
  LAYOUT_CHANGE: 'layout_change',
  SCORE_VIEW_TOGGLE: 'score_view_toggle',
  COMPACT_EXPAND: 'compact_expand',
  SECTION_LINK_COPY: 'section_link_copy',
  THEORY_VIEW: 'theory_view',
  THEORY_RANDOM: 'theory_random',
  THEORY_COPY_MD: 'theory_copy_md',
} as const;

export type AnalyticsEventName =
  (typeof AnalyticsEvents)[keyof typeof AnalyticsEvents];

export type SearchSource = 'header' | 'theory' | 'explorer';

export type NavDestination = 'home' | 'explorer' | 'about' | 'theory';
